import Visibilityjs from 'visibilityjs';
import logger from './logger';

var BrowserWatcher =
/** @class */
function () {
  function BrowserWatcher(timeout) {
    var _this = this;

    this.defaultTimeout = 5000;
    this.state = 'visible';
    this.online = true;
    this.handlersMap = new Map();
    Visibilityjs.change(function (event, state) {
      return _this.handleVisibilityChange(event, state, timeout);
    });
    window.addEventListener('online', function () {
      _this.handleOnline();
    });
    window.addEventListener('offline', function () {
      _this.handleOffline();
    });
  }

  BrowserWatcher.prototype.invokeFn = function (fn) {
    if (fn != null) {
      fn();
    }
  };

  BrowserWatcher.prototype.handleTimeout = function () {
    var _this = this;

    logger.log('enter sleep mode');
    this.handlersMap.forEach(function (_a) {
      var onAway = _a.onAway;
      return _this.invokeFn(onAway);
    });
    this.timeoutId = null;
  };

  BrowserWatcher.prototype.handleVisibilityChange = function (event, next, timeout) {
    var _this = this;

    if (!this.online || this.state === next) {
      return;
    }

    this.state = next;

    if (Visibilityjs.hidden()) {
      logger.log('tab hidden');
      this.timeoutId = window.setTimeout(function () {
        _this.handleTimeout();
      }, timeout !== null && timeout !== void 0 ? timeout : this.defaultTimeout);
    } else {
      logger.log('tab visible');

      if (this.timeoutId) {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
      } else {
        this.handlersMap.forEach(function (_a) {
          var onActive = _a.onActive;
          return _this.invokeFn(onActive);
        });
      }
    }
  };

  BrowserWatcher.prototype.handleOnline = function () {
    this.online = true;
    logger.log('tab online');

    if (this.state !== 'visible') {
      return;
    }

    this.handlersMap.forEach(function (_a) {
      var onActive = _a.onActive;
      return onActive && onActive();
    });
  };

  BrowserWatcher.prototype.handleOffline = function () {
    this.online = false;
    logger.log('tab offline');

    if (this.state !== 'visible') {
      return;
    }

    this.handlersMap.forEach(function (_a) {
      var onAway = _a.onAway;
      return onAway && onAway();
    });
  };

  BrowserWatcher.prototype.watchBrowserConnection = function (type, onAway, onActive) {
    var _this = this;

    var value = {
      onAway: onAway,
      onActive: onActive
    };
    this.handlersMap.set(type, value);
    return function () {
      _this.handlersMap.delete(type);
    };
  };

  return BrowserWatcher;
}();

export default BrowserWatcher;